// extracted by mini-css-extract-plugin
export var banner = "_3-0";
export var icon = "_3-1";
export var message = "_3-2";